module.exports = __webpack_public_path__ + "img/1gPcD4Hsx7FzStajoptkdfDqBFxk2TZji.6fac2332.png";